import { Basket, Confirm, Site, SiteListItem, Store, User } from "@/lib/types";
import { atom } from "jotai";

// export const errorAtom = atom({
//     show: false,
//     severity: "error",
//     message: "",
//     type:""
// })

export const siteDataAtom = atom<Site>();
export const storeDataAtom = atom<Store | null>();
export const userDataAtom = atom<User | null>(null);
export const activeStore = atom<Store | null>(null); //console bölümünde kullanılıyor
export const activeUser = atom<User | null>(null); //console bölümünde kullanılıyor
export const backdropAtom = atom(false);
export const tfaAtom = atom(false);
export const confirmAtom = atom<Confirm>({
  titleAndText: { title: "", text: "" },
  open: false,
  no: () => {},
  yes: () => {},
  buttonText: { no: "", yes: "" },
  loading: false,
});
export const basketAtom = atom<Basket | null>(null);
export const basketLoaderAtom = atom(true);
export const ticketCountAtom = atom(0);
export const refundCountAtom = atom(0);
export const lsPinsPage = atom<"new" | "old">("new");
export const siteListAtom = atom<SiteListItem[]>([]);
